"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ELSTR_BACKEND_VERSION;
(function (ELSTR_BACKEND_VERSION) {
    ELSTR_BACKEND_VERSION["BE1"] = "BE1";
    ELSTR_BACKEND_VERSION["BE2"] = "BE2";
})(ELSTR_BACKEND_VERSION = exports.ELSTR_BACKEND_VERSION || (exports.ELSTR_BACKEND_VERSION = {}));
//# sourceMappingURL=BackendVersion.js.map